(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nav-category"] && !Shopify.designMode) return;
  try {
    class NavDropdownPositioner {
  constructor() {
    this.nav = document.querySelector('[data-nav-category]')?.closest('nav');
    this.mobileMenu = document.querySelector('.js-main-menu');
    this.initialized = false;
    this.lastViewportMode = window.innerWidth <= 1023 ? 'mobile' : 'desktop';
    this.categoryButtons = [];
    this.init();
  }

  init() {
    if (!this.nav) return;
    
    // Add throttle function to limit how often the update function is called
    const throttle = (func, limit) => {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    };

    const updateNavBottom = () => {
      const navRect = this.nav.getBoundingClientRect();
      document.documentElement.style.setProperty('--nav-bottom', `${navRect.bottom}px`);
    };

    // Initialize accessibility features
    this.initAccessibility();
    
    // Remove dropdown links from tab order on desktop
    this.manageDropdownTabOrder();

    // Throttled version to prevent performance issues
    const throttledUpdateNavBottom = throttle(updateNavBottom, 50);

    // Initial position
    updateNavBottom();

    // Update on resize with viewport mode detection
    window.addEventListener('resize', () => {
      updateNavBottom();
      
      // Check if viewport mode has changed (desktop <-> mobile)
      const currentMode = window.innerWidth <= 1023 ? 'mobile' : 'desktop';
      if (currentMode !== this.lastViewportMode) {
        console.log(`Viewport changed from ${this.lastViewportMode} to ${currentMode}`);
        
        // Handle mode change
        if (currentMode === 'mobile') {
          // Switched from desktop to mobile - ensure mobile layout is ready
          this.handleMobileTransition();
        } else {
          // Switched from mobile to desktop - clean up mobile UI elements
          this.handleDesktopTransition();
        }
        
        this.lastViewportMode = currentMode;
      }
      
      // Always handle responsive layout for block cloning
      this.handleResponsiveLayout();
    });
    
    // Add scroll event listener to update nav bottom position
    window.addEventListener('scroll', throttledUpdateNavBottom);
    
    // Setup a MutationObserver to detect changes in the DOM that might affect header height
    this.setupMutationObserver();
    
    // Initialize based on current viewport
    if (this.lastViewportMode === 'mobile') {
      this.handleMobileTransition();
    }
    
    // Initial layout handling
    this.handleResponsiveLayout();
    
    // Mark as initialized
    this.initialized = true;

    // Add debounced resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.handleViewportChange(), 100);
    });
  }
  
  setupMutationObserver() {
    // Create a MutationObserver to watch for DOM changes in the header
    if ('MutationObserver' in window) {
      // Target header element - if nav is not available, try to find the header
      const headerTarget = this.nav ? this.nav.closest('header') : document.querySelector('header');
      
      if (headerTarget) {
        const observer = new MutationObserver((mutations) => {
          // Update position when DOM changes that might affect layout
          const navRect = this.nav.getBoundingClientRect();
          document.documentElement.style.setProperty('--nav-bottom', `${navRect.bottom}px`);
        });
        
        // Watch for changes to the header and its children
        observer.observe(headerTarget, { 
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden']
        });
      }
    }
  }
  
  initAccessibility() {
    // Find all category buttons
    this.categoryButtons = document.querySelectorAll('[data-nav-category] button[data-mobile-toggle]');
    
    this.categoryButtons.forEach(button => {
      // Skip if already initialized
      if (button.hasAttribute('data-a11y-initialized')) return;
      
      // Mark as initialized
      button.setAttribute('data-a11y-initialized', 'true');
      
      // Get the dropdown ID from aria-controls
      const dropdownId = button.getAttribute('aria-controls');
      const dropdown = document.getElementById(dropdownId);
      
      // Add keyboard navigation for Enter key (in addition to natural Tab focus)
      button.addEventListener('keydown', (event) => {
        // Check for Ctrl key modifier to skip menus
        if (event.ctrlKey || event.metaKey) {
          // Allow default Tab behavior to skip through without opening menus
          return;
        }
        
        // Desktop behavior
        if (window.innerWidth > 1023) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            
            // Check if dropdown has any content (links/buttons)
            const hasDropdownContent = dropdown && dropdown.querySelector('a, button');
            
            if (hasDropdownContent) {
              // If there's dropdown content, Enter/Space toggles the dropdown
              button.setAttribute('aria-expanded', 
                button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
              
              // Focus the first link in the dropdown when opened
              if (button.getAttribute('aria-expanded') === 'true') {
                // Restore tab order for dropdown content when explicitly opened
                dropdown.querySelectorAll('a, button').forEach(el => {
                  el.setAttribute('tabindex', '0');
                });
                
                setTimeout(() => {
                  const firstFocusableEl = dropdown.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
                  if (firstFocusableEl) {
                    firstFocusableEl.focus();
                    // Announce to screen readers that submenu is now open
                    const announcement = document.createElement('div');
                    announcement.setAttribute('aria-live', 'polite');
                    announcement.setAttribute('aria-atomic', 'true');
                    announcement.className = 'sr-only';
                    announcement.textContent = `${button.textContent.trim()} submenu expanded`;
                    document.body.appendChild(announcement);
                    setTimeout(() => document.body.removeChild(announcement), 1000);
                  }
                }, 100);
              } else {
                // Remove tab order when collapsed
                dropdown.querySelectorAll('a, button').forEach(el => {
                  el.setAttribute('tabindex', '-1');
                });
              }
            } else {
              // If no dropdown content, Enter/Space navigates to the link
              const categoryLink = button.getAttribute('data-category-link');
              if (categoryLink) {
                window.location.href = categoryLink;
              }
            }
          }
          
          // Close menu with Escape key
          if (event.key === 'Escape') {
            button.setAttribute('aria-expanded', 'false');
            // Remove tab order when dropdown closes via Escape
            dropdown.querySelectorAll('a, button').forEach(el => {
              el.setAttribute('tabindex', '-1');
            });
            button.focus();
            // Announce submenu closure
            const announcement = document.createElement('div');
            announcement.setAttribute('aria-live', 'polite');
            announcement.className = 'sr-only';
            announcement.textContent = `${button.textContent.trim()} submenu collapsed`;
            document.body.appendChild(announcement);
            setTimeout(() => document.body.removeChild(announcement), 1000);
          }
        }
        // Mobile behavior handled by existing mobile menu code
      });
      
      // Remove auto-expansion on focus for accessibility compliance
      // Desktop dropdowns now only open on explicit user action (Enter/Space)
      
      // Click handler - always goes to link if it exists
      button.addEventListener('click', (event) => {
        if (window.innerWidth > 1023) {
          const categoryLink = button.getAttribute('data-category-link');
          if (categoryLink) {
            // Click always navigates to the category link
            window.location.href = categoryLink;
          }
        }
      });
    });
    
    // Add event handlers for dropdown elements
    document.querySelectorAll('[data-nav-dropdown]').forEach(dropdown => {
      // Handle keyboard navigation within the dropdown
      dropdown.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          // Find the parent category button and close the dropdown
          const categoryButton = document.querySelector(`[aria-controls="${dropdown.id}"]`);
          if (categoryButton) {
            categoryButton.setAttribute('aria-expanded', 'false');
            // Remove tab order when dropdown closes
            dropdown.querySelectorAll('a, button').forEach(el => {
              el.setAttribute('tabindex', '-1');
            });
            categoryButton.focus();
          }
        }
      });
      
      // Close dropdown when focus leaves (with delay to allow for focus transitions)
      dropdown.addEventListener('focusout', (event) => {
        setTimeout(() => {
          // Check if focus is still within the dropdown or its parent category
          const parentCategory = dropdown.closest('[data-nav-category]');
          const activeElement = document.activeElement;
          
          if (!parentCategory.contains(activeElement)) {
            const categoryButton = document.querySelector(`[aria-controls="${dropdown.id}"]`);
            if (categoryButton) {
              categoryButton.setAttribute('aria-expanded', 'false');
              // Remove tab order when dropdown closes
              dropdown.querySelectorAll('a, button').forEach(el => {
                el.setAttribute('tabindex', '-1');
              });
            }
          }
        }, 100);
      });
      
      // Add Tab key handler to allow quick escape from dropdown
      dropdown.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' && !event.shiftKey) {
          // On Tab (forward), close dropdown and move to next main nav item
          const categoryButton = document.querySelector(`[aria-controls="${dropdown.id}"]`);
          const parentCategory = dropdown.closest('[data-nav-category]');
          const nextCategory = parentCategory.nextElementSibling;
          
          if (nextCategory && nextCategory.querySelector('button')) {
            event.preventDefault();
            categoryButton.setAttribute('aria-expanded', 'false');
            nextCategory.querySelector('button').focus();
          }
        }
      });
    });
    
    // Special handling for mobile submenu navigation
    this.initMobileSubmenuAccessibility();
  }
  
  // Add this new method for mobile submenu accessibility
  initMobileSubmenuAccessibility() {
    // Get all mobile submenus
    const mobileSubmenus = document.querySelectorAll('.mobile-submenu');
    
    mobileSubmenus.forEach(submenu => {
      if (submenu.hasAttribute('data-a11y-initialized')) return;
      submenu.setAttribute('data-a11y-initialized', 'true');
      
      // Handle after the submenu becomes active
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class' && 
              submenu.classList.contains('active')) {
            
            // Ensure all column toggles in this submenu are initialized
            const columnToggles = submenu.querySelectorAll('[data-mobile-column-toggle]:not([data-column-initialized])');
            
            if (columnToggles.length > 0) {
              console.log('Initializing column toggles in active submenu:', columnToggles.length);
              
              // Trigger a click event on each for initialization
              columnToggles.forEach(toggle => {
                // Dispatch a custom event that our nav-column.liquid JS can listen for
                const event = new CustomEvent('submenu-activated', { bubbles: true });
                toggle.dispatchEvent(event);
                
                // Mark as initialized ourselves as a backup
                toggle.setAttribute('data-column-initialized', 'true');
              });
            }
          }
        });
      });
      
      observer.observe(submenu, { attributes: true });
    });
  }
  
  // Called when switching from desktop to mobile
  handleMobileTransition() {
    console.log('Transitioning to mobile view');
    
    // Clone desktop blocks to mobile containers if needed
    this.handleResponsiveLayout();
    
    // Reset mobile navigation initialization flag to force reinitialization
    window.mobileNavigationInitialized = false;
    
    // Update ARIA attributes for mobile
    this.categoryButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
    
    // Force reinitialization of mobile navigation
    if (typeof initializeMobileNavigation === 'function') {
      // This function is defined in main-navigation.liquid
      setTimeout(initializeMobileNavigation, 100);
    } else {
      console.warn('initializeMobileNavigation function not found');
    }
    
    // Initialize mobile submenu accessibility
    setTimeout(() => {
      this.initMobileSubmenuAccessibility();
    }, 500);
  }
  
  // Called when switching from mobile to desktop
  handleDesktopTransition() {
    console.log('Transitioning to desktop view');
    
    // Remove all mobile-specific active states
    document.querySelectorAll('.mobile-submenu.active').forEach(submenu => {
      submenu.classList.remove('active');
      submenu.style.transform = 'translateX(100%)';
      submenu.style.opacity = '0';
      submenu.style.visibility = 'hidden';
    });
    
    // Reset any submenu-active state on main menu
    const mainMenu = document.querySelector('.js-main-menu');
    if (mainMenu) {
      mainMenu.classList.remove('submenu-active');
    }
    
    // Reset ARIA attributes for desktop
    this.categoryButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
    
    // Reset mobile titles
    document.querySelectorAll('.mobile-submenu-title').forEach(title => {
      title.textContent = '';
    });
    
    // Hide all mobile-specific UI elements that might be visible
    document.querySelectorAll('.mobile-toggle-icon, .mobile-back-button').forEach(element => {
      element.style.display = 'none';
    });
    
    // Restore desktop visibility
    document.querySelectorAll('.desktop-dropdown').forEach(dropdown => {
      dropdown.style.display = '';
    });
  }
  
  handleResponsiveLayout() {
    const isMobile = window.innerWidth <= 1023;
    
    // Only run this once after page load and on viewport changes
    document.querySelectorAll('[data-nav-category]').forEach(category => {
      const desktopContainer = category.querySelector('.desktop-blocks-container');
      const mobileContainer = category.querySelector('.mobile-blocks-container');
      
      if (!desktopContainer || !mobileContainer) return;
      
      // On mobile, clone blocks from desktop to mobile container
      if (isMobile && mobileContainer.children.length === 0) {
        console.log('Cloning desktop blocks to mobile container');
        // Create clones for mobile view to avoid DOM manipulation issues
        Array.from(desktopContainer.children).forEach(child => {
          const clone = child.cloneNode(true);
          mobileContainer.appendChild(clone);
        });
        
        // Force reinitialization of mobile elements after cloning
        if (typeof initializeMobileNavigation === 'function') {
          setTimeout(initializeMobileNavigation, 100);
        }
      }
      
      // Update visibility of mobile/desktop elements based on current viewport
      if (isMobile) {
        // Show mobile elements
        category.querySelectorAll('.mobile-toggle-icon').forEach(icon => {
          icon.style.display = 'inline-flex';
        });
      } else {
        // Show desktop elements, hide mobile elements
        category.querySelectorAll('.mobile-toggle-icon').forEach(icon => {
          icon.style.display = 'none';
        });
      }
    });
  }
  
  initMobileToggles() {
    // Do not initialize if a global handler exists
    if (window.mobileNavigationInitialized) return;
    
    console.log('Mobile toggles initialized in NavDropdownPositioner');
    
    // Simple initialization without DOM manipulation
    const mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
    
    // Just log the count, don't do anything else as main-navigation.liquid handles this
    console.log('Found mobile toggles:', mobileToggles.length);
  }
  
  initBackButtons() {
    // Do not initialize if a global handler exists
    if (window.mobileNavigationInitialized) return;
    
    console.log('Back buttons initialized in NavDropdownPositioner');
    
    // Simple initialization without DOM manipulation
    const backButtons = document.querySelectorAll('[data-mobile-back]');
    
    // Just log the count, don't do anything else as main-navigation.liquid handles this
    console.log('Found back buttons:', backButtons.length);
  }

  handleViewportChange() {
    const currentWidth = window.innerWidth;
    const wasDesktop = this.lastViewportMode === 'desktop';
    const isNowDesktop = currentWidth > 1023;

    if (wasDesktop !== isNowDesktop) {
      // Add transitioning class
      document.documentElement.classList.add('viewport-transitioning');

      // Reset all states
      this.resetAllStates();

      // Update viewport mode
      this.lastViewportMode = isNowDesktop ? 'desktop' : 'mobile';

      // Force reinitialization of mobile navigation if needed
      if (!isNowDesktop) {
        window.mobileNavigationInitialized = false;
        window.initializeMobileNavigation();
      }

      // Remove transitioning class after a delay
      setTimeout(() => {
        document.documentElement.classList.remove('viewport-transitioning');
      }, 100);
    }
  }

  resetAllStates() {
    // Reset mobile states
    document.body.classList.remove('mobile-menu-is-active');
    this.mobileMenu?.classList.remove('is-active', 'submenu-active');
    
    // Reset all mobile submenus
    document.querySelectorAll('.mobile-submenu').forEach(submenu => {
      submenu.classList.remove('active');
      submenu.style.transform = 'translateX(100%)';
      submenu.style.opacity = '0';
      submenu.style.visibility = 'hidden';
    });

    // Reset mobile titles
    document.querySelectorAll('.mobile-submenu-title').forEach(title => {
      title.textContent = '';
    });

    // Reset desktop dropdowns
    document.querySelectorAll('.desktop-dropdown').forEach(dropdown => {
      dropdown.style.opacity = '0';
      dropdown.style.visibility = 'hidden';
    });
  }
  
  manageDropdownTabOrder() {
    // On desktop, remove all dropdown links from tab order by default
    if (window.innerWidth > 1023) {
      document.querySelectorAll('.desktop-dropdown a, .desktop-dropdown button').forEach(element => {
        element.setAttribute('tabindex', '-1');
      });
    }
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  // Just position the dropdowns, let main-navigation.liquid handle the toggle logic
  window.navDropdownPositioner = new NavDropdownPositioner();
  
  // Manually trigger a resize event after a delay
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
  
  // Reinitialize accessibility after any potential DOM changes
  setTimeout(() => {
    if (window.navDropdownPositioner) {
      window.navDropdownPositioner.initAccessibility();
    }
  }, 1000);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nav-column"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // Add mobile column toggle functionality
  function initializeColumnToggles() {
    // Get all uninitialized column toggles
    const mobileColumnToggles = document.querySelectorAll('[data-mobile-column-toggle]:not([data-column-initialized])');
    
    console.log('Initializing column toggles:', mobileColumnToggles.length);
    
    mobileColumnToggles.forEach(toggle => {
      // Mark as initialized to avoid double-binding
      toggle.setAttribute('data-column-initialized', 'true');
      
      // Handle click events
      toggle.addEventListener('click', function(e) {
        // Only handle on mobile
        if (window.innerWidth > 1023) return;
        
        // Log the click for debugging
        console.log('Column toggle clicked:', this.textContent.trim());
        
        // Find nearest column and links using DOM traversal
        // This is more reliable than using IDs with Shopify's cloned elements
        const column = this.closest('.nav-column');
        const links = column.querySelector('.nav-column-links');
        
        if (!links) {
          console.warn('Could not find .nav-column-links');
          return;
        }
        
        // Toggle visibility of the links
        const isCurrentlyHidden = links.style.display === 'none' || getComputedStyle(links).display === 'none';
        
        // IMPORTANT: Toggle active class FIRST, to help CSS rules take effect
        if (isCurrentlyHidden) {
          this.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
          
          // Force visibility with !important
          links.style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important;';
          
          // Dispatch a custom event so other components can react
          const event = new CustomEvent('column-links-shown', { bubbles: true });
          links.dispatchEvent(event);
        } else {
          this.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
          links.style.cssText = '';
        }
        
        // Prevent event propagation
        e.stopPropagation();
      }, true); // Use capture to ensure this runs before other handlers
      
      // Add keyboard support for Enter and Space
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
      
      // Add custom event listener for submenu-activated
      toggle.addEventListener('submenu-activated', function(e) {
        console.log('Submenu activated event received for:', this.textContent.trim());
        
        // Find nearest column and links
        const column = this.closest('.nav-column');
        const links = column.querySelector('.nav-column-links');
        
        if (links) {
          // Force links to be visible with !important
          if (this.classList.contains('active') || this.getAttribute('aria-expanded') === 'true') {
            links.style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important;';
            console.log('Forced column links visible for active heading');
          }
        }
      });
      
      // Check initial state - if heading is active, make sure links are visible
      if (toggle.classList.contains('active') || toggle.getAttribute('aria-expanded') === 'true') {
        const column = toggle.closest('.nav-column');
        const links = column.querySelector('.nav-column-links');
        if (links) {
          links.style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important;';
          console.log('Initial state: Forced column links visible for active heading');
        }
      }
    });
    
    // Add keyboard navigation for desktop
    if (window.innerWidth > 1023) {
      document.querySelectorAll('.nav-column-links a').forEach(link => {
        link.addEventListener('keydown', function(e) {
          // Close dropdown with Escape
          if (e.key === 'Escape') {
            const categoryButton = this.closest('[data-nav-category]')?.querySelector('[data-mobile-toggle]');
            if (categoryButton) {
              categoryButton.setAttribute('aria-expanded', 'false');
              categoryButton.focus();
            }
          }
        });
      });
    }
  }
  
  // Initialize on load
  initializeColumnToggles();
  
  // Initialize again after a delay for any late-loading elements
  setTimeout(initializeColumnToggles, 500);
  
  // Initialize again after another delay to catch any late Shopify cloned elements
  setTimeout(initializeColumnToggles, 1500);
  
  // Observer for new elements
  const observer = new MutationObserver(function(mutations) {
    let newToggles = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // ELEMENT_NODE
            // Check if this element or its children have uninitialized toggles
            if ((node.hasAttribute && node.hasAttribute('data-mobile-column-toggle') && !node.hasAttribute('data-column-initialized')) ||
                (node.querySelector && node.querySelector('[data-mobile-column-toggle]:not([data-column-initialized])'))) {
              newToggles = true;
            }
          }
        });
      }
    });
    
    if (newToggles) {
      console.log('New column toggles detected, initializing');
      initializeColumnToggles();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false
  });
  
  // Special handler for mobile cloned elements that might appear later
  document.addEventListener('click', function(e) {
    // If we clicked something inside the mobile menu
    if (e.target.closest('.mobile-submenu')) {
      // Try to reinitialize all column toggles in the mobile submenu
      const mobileToggles = e.target.closest('.mobile-submenu').querySelectorAll('[data-mobile-column-toggle]:not([data-column-initialized])');
      if (mobileToggles.length > 0) {
        console.log('Found uninitialized mobile toggles after click:', mobileToggles.length);
        initializeColumnToggles();
      }
      
      // Also check if any active toggles need their links forced visible
      const activeToggles = e.target.closest('.mobile-submenu').querySelectorAll('.nav-column-heading.active, [aria-expanded="true"]');
      activeToggles.forEach(toggle => {
        const column = toggle.closest('.nav-column');
        const links = column.querySelector('.nav-column-links');
        if (links) {
          links.style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important;';
          console.log('Force visible links for active toggle after click');
        }
      });
    }
  }, true);
  
  // Force open any active mobile column links
  function forceOpenMobileColumnLinks() {
    if (window.innerWidth <= 1023) {
      // Target both class-based and attribute-based active states
      document.querySelectorAll('.nav-column-heading.active, [data-mobile-column-toggle][aria-expanded="true"]').forEach(heading => {
        const column = heading.closest('.nav-column');
        const links = column.querySelector('.nav-column-links');
        if (links && (links.style.display === 'none' || getComputedStyle(links).display === 'none')) {
          links.style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important;';
          console.log('Force opened mobile column links for:', heading.textContent.trim());
        }
      });
    }
  }
  
  // Run on initial load and then periodically
  forceOpenMobileColumnLinks();
  setInterval(forceOpenMobileColumnLinks, 500); // Check more frequently
  
  // Manually check opened state after any DOM changes that might affect mobile menu
  window.addEventListener('resize', forceOpenMobileColumnLinks);
  document.addEventListener('column-links-shown', forceOpenMobileColumnLinks);
  
  // Run as soon as DOM is ready
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    forceOpenMobileColumnLinks();
  }

  // Add a special handler for viewport changes
  function handleViewportChange() {
    const currentViewportWidth = window.innerWidth;
    
    // Reset all column toggles when transitioning between mobile and desktop
    const isDesktopNow = currentViewportWidth > 1023;
    const wasMobileTransition = !isDesktopNow && window.lastViewportMode === 'desktop';
    
    // Update the viewport mode
    window.lastViewportMode = isDesktopNow ? 'desktop' : 'mobile';
    
    if (wasMobileTransition) {
      console.log('Viewport transition to mobile - reinitializing all column toggles');
      
      // Force reinitialization of all column toggles
      document.querySelectorAll('.nav-column-heading[data-column-initialized]').forEach(toggle => {
        toggle.removeAttribute('data-column-initialized');
      });
      
      // Reinitialize
      window.mobileNavigationInitialized = false;
      initializeColumnToggles();
      forceOpenMobileColumnLinks();
    }
  }
  
  // Store initial viewport mode
  window.lastViewportMode = window.innerWidth > 1023 ? 'desktop' : 'mobile';
  
  // Add resize listener for viewport transitions
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleViewportChange, 100);
  });
  
  // Run on initial load and then periodically
  forceOpenMobileColumnLinks();
});
  } catch(e) { console.error(e); }
})();

})();
